export const canAccessPensionCalculators = role =>
  ['staff', 'advisers', 'administrators'].includes(String(role || '').trim().toLowerCase());

export const pensionCalculators = [
  {
    "id": "tax-free-cash",
    "label": "Tax Free Cash",
    "menuLabel": "Tax Free Cash Calculator",
    "description": "Compare existing-plan and transfer tax-free cash.",
    "page": "/"
  },
  {
    "id": "pension-shortfall",
    "label": "Pension Shortfall",
    "menuLabel": "Pension Shortfall Modeller",
    "description": "Project pension fund value and retirement income.",
    "page": "/pension-shortfall"
  },
  {
    "id": "critical-yield",
    "label": "Critical Yield",
    "menuLabel": "Critical Yield Calculator",
    "description": "Compare the additional yield required after transfer.",
    "page": "/critical-yield"
  },
  {
    "id": "annuity-risk",
    "label": "Annuity & Risk of Ruin",
    "menuLabel": "Annuity & Risk of Ruin Calculator",
    "description": "Compare annuity income and withdrawals using March 2025 rates.",
    "page": "/annuity-risk"
  },
  {
    "id": "growth-required",
    "label": "Growth Required",
    "menuLabel": "Growth Required Calculator",
    "description": "Calculate growth needed to reach a target fund.",
    "page": "/growth-required"
  },
  {
    "id": "reduction-in-yield",
    "label": "Reduction in Yield",
    "menuLabel": "Total Reduction in Yield Calculator",
    "description": "Estimate the annual impact of product, fund and adviser fees.",
    "page": "/reduction-in-yield"
  },
  {
    "id": "gar",
    "label": "GAR",
    "menuLabel": "Guaranteed Annuity Rate Calculator",
    "description": "Compare plan-specific GAR benefits and open-market quotes.",
    "page": "/gar"
  },
  {
    "id": "weighted-average",
    "label": "Weighted Average",
    "menuLabel": "Weighted Average Calculator",
    "description": "Calculate the weighted rate across fund allocations.",
    "page": "/weighted-average"
  }
];
